/** Dashboard item type discriminators */
export enum DashboardItemType {
  CHART = 'chart',
  WIDGET = 'widget',
  TEXT = 'text',
  DATE_PICKER = 'date_picker',
}

/** Grid row unit height (px) shared by the editor grid (react-grid-layout's
 *  `rowHeight` prop) and the view grid's cell-height formula, so a saved
 *  widget's `layout.h` renders at the same pixel height on both routes. */
export const DASHBOARD_GRID_ROW_HEIGHT = 50

/** react-query key for the dashboard-previews list. Shared with the command
 *  palette, which runs the same query so the two share one cache entry. */
export const CUSTOM_DASHBOARD_PREVIEWS_QUERY_KEY = 'custom-dashboard-previews'
